export default __webpack_public_path__ + "static/media/form-details-icon.307bd2dd.svg";